import { Component, Injector, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Dialog } from 'primeng/dialog';

@Component({
    selector: 'app-avisos',
    templateUrl: './avisos.component.html',
    styleUrls: ['./avisos.component.css'],
})
export class AvisosComponent {
    @ViewChild('avisoDialog') dialog: Dialog;

    @Input() avisos = [];
    @ViewChild('avisos_modal', { static: true }) avisos_modal: ModalDirective;

    constructor(
        public injector: Injector,
        public translateService: TranslateService
    ) {}

    show_aviso = false;
    aviso = null;

    show_all_avisos() {
        if (this.avisos.length > 0) {
            this.avisos_modal.show();
        }
    }

    select_aviso(data) {
        if (window.outerWidth < 992) {
            this.dialog.maximized = false;
            this.dialog.maximizable = false;
            this.dialog.maximize();
        }
        this.aviso = data.data;
        this.show_aviso = true;
    }
}
